import styled from "styled-components";
import Typography from "@pagepro-monorepo/ui/lib/components/styles/Typography";
import shouldForwardProp from "@pagepro-monorepo/ui/lib/utils/shouldForwardProp";

export const Wrapper = styled.div`
  width: 100%;
  max-width: 39.375rem;
  margin: 0 auto;
`;

export const Text = styled(Typography)
  .withConfig({
    shouldForwardProp
  })
  .attrs({
    variant: "body3",
    fontWeight: "medium"
  })`
  text-align: center;
  position: relative;
  &::before,
  &::after {
    font-weight: ${({ theme }) => theme.fontWeights.light};
    font-size: 7.5rem;
    font-family: ${({ theme }) => theme.fonts.body};
    line-height: 1;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.primary};
  }
  &::before {
    content: "\u201C";
  }
  &::after {
    content: "\u201E";
  }
`;
